import React from 'react'
import ProductDetailHead from '../../ProductComponents/ProductDetailHead'
import ProductFeatures from '../../ProductComponents/ProductFeatures'
import ProductDescription from '../../ProductComponents/ProductDescription'
import ProductTableCol from '../../ProductComponents/ProductTableCol'
import OtherDetails from '../../ProductComponents/OtherDetails'
import image1 from "../../../../assets/images/product/unipack-filter-press/07.jpg"
import image2 from "../../../../assets/images/product/unipack-filter-press/08.jpg"

function UnipackManualSilicon() {
    return (
        <>
            <ProductDetailHead productTitle={"Unipack Plate and Frame Type Filter Press Manual Closing System (With Silicon Washer)"} productPrice={""} carImg={[image1,image2]}>
                <ProductTableCol leftValue={"Brand"} rightValue={"Unipack"} />
                <ProductTableCol leftValue={"Usage/Application"} rightValue={"Filtration of pharmaceuticals, chemicals, beverages, breweries, Distilleries & food industries."} />
                <ProductTableCol leftValue={"Design"} rightValue={"Universally accepted vertical plate & frame type."} />
                <ProductTableCol leftValue={"Filter Area"} rightValue={"0.273 M2 (per plate) 13 mm size"} />
                <ProductTableCol leftValue={"Capacity"} rightValue={"1000 to 4000 liters/hr"} />
                <ProductTableCol leftValue={"Finishing"} rightValue={"Mirror finish with electro-polished plates, frames & screen."} />
                <ProductTableCol leftValue={"Size"} rightValue={"40 x 40 cm"} />
                <ProductTableCol leftValue={"Cake Holding Frame Size"} rightValue={"40 mm"} />
                <ProductTableCol leftValue={"Cake Holding Frame Capacity"} rightValue={"5.48 liters"} />
                <ProductTableCol leftValue={"Material Grade"} rightValue={"SS 304/ SS 316"} />
            </ProductDetailHead>
            <ProductFeatures productFeatures={["Microbiological reliability ", "Universal application ", "Double filtration in one system","Individual adaption of outputs. "]} />
            <OtherDetails title={"Construction :"} />
            <ProductDescription productDescription={"Horizontal square body having vertical plates & frames fitted one behind the other making parallel flow passage."} />
        </>
    )
}

export default UnipackManualSilicon
